import { url as URL}  from "api";

export const url = URL; //this one

export default {
  TABLET_SIZE: 980,
  MOBILE_SIZE: 640,
  SERVER_URL: url,
};
